var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoyaltyCards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "#00AFEE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 44,
    height: 28,
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 22,
    width: 44,
    height: 28,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 36 l-4-4 -4 4 0-8 8 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoyaltyCards);
export default __webpack_public_path__ + "static/media/Loyalty Cards.6fbd97072054920cc6ceac89564ca976.svg";
export { ForwardRef as ReactComponent };